const SCOPE_HANDOFF_STORAGE_KEY = "business_context_scope_handoff_v1"
const SCOPE_HANDOFF_TTL_MS = 120_000

interface PersistedScopeHandoff {
  scopeId: string
  accountId?: string
  tokenFingerprint: string
  issuedAt: number
}

function createTokenFingerprint(token: string) {
  let firstHash = 0x811C9DC5
  let secondHash = 0x9E3779B9
  for (let index = 0; index < token.length; index += 1) {
    const code = token.charCodeAt(index)
    firstHash = Math.imul(firstHash ^ code, 0x01000193)
    secondHash = Math.imul(secondHash ^ code, 0x85EBCA6B)
  }
  return `${token.length}:${(firstHash >>> 0).toString(36)}:${(secondHash >>> 0).toString(36)}`
}

function removeScopeHandoff() {
  try {
    sessionStorage.removeItem(SCOPE_HANDOFF_STORAGE_KEY)
  } catch {
    // A handoff is an optimization; server currentScope remains authoritative.
  }
}

export function writeScopeHandoff(
  scopeId: string,
  token: string,
  issuedAt = Date.now(),
  accountId = "",
) {
  if (!scopeId || !token) return false
  try {
    sessionStorage.setItem(SCOPE_HANDOFF_STORAGE_KEY, JSON.stringify({
      scopeId,
      ...(accountId ? { accountId } : {}),
      tokenFingerprint: createTokenFingerprint(token),
      issuedAt,
    } satisfies PersistedScopeHandoff))
    return true
  } catch {
    return false
  }
}

export function consumeScopeHandoff(
  token: string,
  now = Date.now(),
  accountId = "",
) {
  if (!token) return undefined
  try {
    const raw = sessionStorage.getItem(SCOPE_HANDOFF_STORAGE_KEY)
    if (!raw) return undefined
    const parsed = JSON.parse(raw) as Partial<PersistedScopeHandoff>
    if (
      typeof parsed.scopeId !== "string"
      || !parsed.scopeId
      || typeof parsed.issuedAt !== "number"
      || now - parsed.issuedAt > SCOPE_HANDOFF_TTL_MS
    ) {
      removeScopeHandoff()
      return undefined
    }
    if (parsed.tokenFingerprint !== createTokenFingerprint(token)) {
      return undefined
    }
    if (parsed.accountId && parsed.accountId !== accountId) {
      return undefined
    }
    removeScopeHandoff()
    return parsed.scopeId
  } catch {
    removeScopeHandoff()
    return undefined
  }
}
